import { render, staticRenderFns } from "./work-order-issued.vue?vue&type=template&id=0584d11f&scoped=true"
import script from "./work-order-issued.vue?vue&type=script&lang=js"
export * from "./work-order-issued.vue?vue&type=script&lang=js"
import style0 from "./work-order-issued.vue?vue&type=style&index=0&id=0584d11f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0584d11f",
  null
  
)

export default component.exports